import type {
    LegacyCheckoutStatus,
    OrderStatus,
    PaymentStatus,
    RedirectionInstructions,
} from '@eventbrite/checkout-fairy-api';
import { TlzEnvironment, _getOrderStatusUrl } from '../constants';

export const getOrderStatus = async ({
    env,
    eventId,
    orderId,
}: {
    env: TlzEnvironment;
    eventId: string;
    orderId: string;
}): Promise<{
    orderStatus: OrderStatus;
    paymentStatus: PaymentStatus;
    redirectionInstructions: RedirectionInstructions | null;
    status: LegacyCheckoutStatus;
}> => {
    const response = await fetch(
        _getOrderStatusUrl({
            env,
            eventId,
            orderId,
        }),
        {
            method: 'GET',
            credentials: 'include',
        },
    );

    const body = await response.json();

    if (body.error) {
        throw new Error(
            `CheckoutStatusAPI returned a body describing an error: ${body.error} (full body: ${body})`,
        );
    }

    return body;
};
